import React from 'react'
import { Link } from 'react-router-dom'
import t from '@jetshop/intl'

export function getExternalCustomerLoginMessage(status, routes) {
   switch (status) {
      case 'NON_EXISTING_CUSTOMER':
         return (
            <p>
               {t('Your account does not exist.')}{' '}
               <Link to={routes.signup.path}>{t('Sign up here')}</Link>.
            </p>
         )

      case 'ACTIVATION_REQUIRED':
         return (
            <p>
               {t(
                  'Your membership needs to be activated before you can log in.'
               )}
            </p>
         )

      case 'ADDITIONAL_USER_DATA_REQUIRED':
         return (
            <p>
               {t(
                  'We need more information to complete your registration before you can log in.'
               )}
            </p>
         )

      case 'COUNTRY_NOT_VALID':
         return (
            <p>
               {t('Membership is not available in your country.')}
            </p>
         )

      default:
         return null
   }
}
